import React from 'react';
import classNames from 'clsx';

type CardProps = {
  children: React.ReactNode;
  className?: string;
};

export const Card = ({ children, className }: CardProps) => {
  return (
    <div
      className={classNames('p-6 bg-neutral-0 rounded-lg shadow', className)}
    >
      {children}
    </div>
  );
};
